import { render, staticRenderFns } from "./InterviewCameraCheck.vue?vue&type=template&id=c39ff79a&scoped=true&"
import script from "./InterviewCameraCheck.vue?vue&type=script&lang=js&"
export * from "./InterviewCameraCheck.vue?vue&type=script&lang=js&"
import style0 from "./InterviewCameraCheck.vue?vue&type=style&index=0&id=c39ff79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39ff79a",
  null
  
)

/* custom blocks */
import block0 from "./InterviewCameraCheck.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./InterviewCameraCheck.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VResponsive,VRow})
